'use strict';

var _ = require('lodash');
var BookingMatrixTooltipFactory = function BookingMatrixTooltipFactory() {
  var MARKET_MODE = 'market-screen';
  function BookingMatrixTooltip() {}
  BookingMatrixTooltip.constructor = BookingMatrixTooltip;
  BookingMatrixTooltip.prototype.getBuilder = function (mode) {
    return function (cellData, wholeGridData) {
      var rowData = wholeGridData[cellData.row];
      var fieldName = 'totalBookingsRtp' + _.padStart(cellData.title, 5, '0');
      var cabinMode = mode !== MARKET_MODE;
      var aggregateField = cabinMode ? 'cabin' : 'classGroup';
      var bookingsSum = _.chain(wholeGridData).filter({
        entryKey: rowData.entryKey
      }).reduce(function (result, row) {
        var value = row[fieldName];
        if (value !== null && value !== undefined) {
          var aggregateKey = row[aggregateField];
          result[aggregateKey] = result[aggregateKey] === undefined ? value : result[aggregateKey] + value;
        }
        return result;
      }, {}).value();
      if (!_.isEmpty(bookingsSum)) {
        var tooltipContent = _.template(require('../templates/booking-matrix-tooltip.html'));
        var tooltipData = {
          title: cellData.title,
          rowLabel: cabinMode ? 'Cabin' : 'Class Grp',
          bookingsSum: bookingsSum
        };
        return {
          htmlContent: tooltipContent(tooltipData).replace(/>\s*</g, '><'),
          placement: 'top'
        };
      } else {
        return '';
      }
    };
  };
  return BookingMatrixTooltip;
};
module.exports = BookingMatrixTooltipFactory;